document.addEventListener('DOMContentLoaded', () => {
  const zoomTriggers = document.querySelectorAll('.hover-zoom-trigger');

  zoomTriggers.forEach((trigger) => {
    const media = trigger.querySelector('.hover-zoom-wrap');
    const zoomTarget = trigger.querySelector('.hover-zoom-wrap img, .hover-zoom-wrap picture');

    if (!media || !zoomTarget) return;

    trigger.addEventListener('mousemove', (e) => {
      const rect = media.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;

      zoomTarget.style.transformOrigin = `${x}% ${y}%`;
      trigger.classList.add('is-zooming');
    });

    trigger.addEventListener('mouseenter', () => {
      trigger.classList.add('is-zooming');
    });

    trigger.addEventListener('mouseleave', () => {
      trigger.classList.remove('is-zooming');
      zoomTarget.style.transformOrigin = 'center center';
    });
  });
});